import {Modal} from "antd";
import React from 'react';
import Iframe from "react-iframe";
import {UI} from "../../../core/utilities/ui";
import "./PayByMeModal.scss";

interface IProps {
  url: string;
}

const PayByMeModal = (props: IProps) => {

  return (
    <Modal
      className="pay-by-me-modal"
      maskStyle={UI.modalMaskStyle()}
      visible={true}
      closable={false}
      footer={false}
      centered
      destroyOnClose
    >
      <div className="content">
        <Iframe
          id="pay-by-me-iframe"
          url={props.url}
          width="350px"
          height="455px"
          position="relative"
        />
      </div>
    </Modal>
  );
}

export default PayByMeModal;
